import { baseApi } from "api/BaseApi";

interface TriggerTdNewDecisionPayload {
  td_id: number;
}

const tdNotificationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    triggerNotifyTdNewDecision: build.mutation<void, TriggerTdNewDecisionPayload>(
      {
        query: (body) => ({
          url: "v2/notifications/td-new-decision/",
          method: "POST",
          body,
        }),
      },
    ),
  }),
  overrideExisting: false,
});

export const { useTriggerNotifyTdNewDecisionMutation } = tdNotificationsApi;
